const enJSON = {
  Tokyo: 'Muraqabah Pilgrimage portal',
  'Accent Sidebar': 'Accent Sidebar',
  'Tokyo White React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo Black React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  '&copy; 2026 - Muraqabah Pilgrimage portal':
    '&copy; 2026 - Muraqabah Pilgrimage portal',
  'Muraqabah Pilgrimage portal': 'Muraqabah Pilgrimage portal',
  Dashboards: 'Dashboards',
  Dashboard: 'Dashboard',
  General: 'General',
  Roles: 'Roles',
  'Vendor Management': 'Vendor Management',
  Vendors: 'Vendors',
  Package: 'Package',
  Packages: 'Packages',
  Master: 'Master',
  'Master Data': 'Master Data',
  Master_Data_type: 'Master Data Type is required',
  Inquiry: 'Inquiry',
  'Inquiry Management': 'Inquiry Management',
  Inquiries: 'Inquiries',
  'Service Management': 'Service Management',
  'Business Profile': 'Business Profile',
  your_analytics: 'These are your analytics stats for today',
  Search_by_name: 'Search by name, shortcode or description...',
  Welcome: 'Welcome',
  'Active Referrals': 'Active Referrals',
  'See referring domains': 'See referring domains',
  'which sent most traffic': 'which sent most traffic',
  'Pending Invitations': 'Pending Invitations',
  'Not opened yet': 'Not opened yet',
  'See all invitations': 'See all invitations',
  'Sessions by Country': 'Sessions by Country',
  'Bounce Rate': 'Bounce Rate',
  'See all links': 'See all links',
  'with high bounce rate.': 'with high bounce rate.',
  Conversion: 'Conversion',
  'with the best conversion rates.': 'with the best conversion rates.',
  'See products': 'See products',
  'Audience Overview': 'Audience Overview',
  Today: 'Today',
  Yesterday: 'Yesterday',
  'Last month': 'Last month',
  'Last year': 'Last year',
  Users: 'Users',
  'New users': 'New users',
  'Page views': 'Page views',
  'Avg. session duration': 'Avg. session duration',
  Sessions: 'Sessions',
  Conversions: 'Conversions',
  'Sales Today': 'Sales Today',
  'Customers per month': 'Customers per month',
  'Earnings Report': 'Earnings Report',
  'Top Landing Pages': 'Top Landing Pages',
  Impressions: 'Impressions',
  Clicks: 'Clicks',
  'Visit URL': 'Visit URL',
  'Traffic Sources': 'Traffic Sources',
  'Generate Chart': 'Generate Chart',
  'pages/session': 'pages/session',
  'New Sessions': 'New Sessions',
  'User & Role Management': 'User & Role Management',
  Management: 'Management',
  user_can_be_managed:
    'All aspects related to the user can be managed from this page',
  Add: 'Add',
  role_can_be_managed:
    'All aspects related to the role can be managed from this page',
  Role_required: 'Role Name is required',
  'Add new role': 'Add new role',
  'Edit role details': 'Edit role details',
  fields_new_role: 'Fill in the fields below to add a new role.',
  'Role Name': 'Role Name',
  'Short Code': 'Short Code',
  Description: 'Description',
  Cancel: 'Cancel',
  Save: 'Save',
  Edit: 'Edit',
  Url: 'Url',

  Delete: 'Delete',
  'Tour Itinerary': 'Tour Itinerary',
  below_to_edit: 'Fill in the fields below to edit role details.',
  Description_required: 'Description is required',
  Short_Code_required: 'Short Code is required',
  Special_Chars_not_allowed: 'Special Chars & Numbers not allowed.',
  'Search by name, shortcode or description...':
    'Search by name, shortcode or description...',
  'Sr. No.': 'Sr. No.',
  Name: 'Name',
  Shortcode: 'Shortcode',
  'Created By': 'Created By',
  'Modified By': 'Modified By',
  Actions: 'Actions',
  'Loading...': 'Loading...',
  'No results found': 'No results found',
  'Advanced View': 'Advanced View',
  'Assigned Roles': 'Assigned Roles',
  Password: 'Password',
  Email: 'Email',
  'Last name': 'Last name',
  'First name': 'First name',
  Airlines: 'Airlines',
  'Bus Services': 'Bus Services',
  'Select Bus Services': 'Select Bus Services',
  'Select room sharing': 'Select room sharing',
  'Room Sharing': 'Room Sharing',
  'Package Type': 'Package Type',
  'Select package type': 'Select package type',
  'Package Details': 'Package Details',
  'Package Name': 'Package Name',
  Departure: 'Departure',
  'Package Room Sharing': 'Package Room Sharing',
  'Package Airline': 'Package Airline',
  'Package Bus Services': 'Package Bus Services',
  'Package Amount': 'Package Amount',
  'Package Inquiry Date': 'Package Inquiry Date',
  'Inquiry Date': 'Inquiry Date',
  'Vendor Name': 'Vendor Name',
  'Phone Number': 'Phone Number',
  'Customer Email': 'Customer Email',
  'Customer Name': 'Customer Name',
  Status: 'Status',
  'Customer Phone No.': 'Customer Phone No.',
  'Customer Phone Number': 'Customer Phone Number',
  Search_by_customer_name:
    'Search by customer name, email,phone no.,package type,name,room sharing...',
  'Status Type': 'Status Type',
  'Select status type': 'Select status type',
  'NEW LEAD': 'NEW LEAD',
  'FOLLOW UP': 'FOLLOW UP',
  CLOSED: 'CLOSED',
  'NOT INTERESTED': 'NOT INTERESTED',
  'NOT CONTACTED': 'NOT CONTACTED',
  'Room Sharing is required': 'Room Sharing is required',
  PACKAGE_TYPE: 'PACKAGE_TYPE',
  AIRLINES_TYPE: 'AIRLINES_TYPE',
  BUS_TYPE: 'BUS_TYPE',
  ROOM_SHARING: 'ROOM_SHARING',
  INCLUSION_TYPE: 'INCLUSION_TYPE',
  EXCLUSION_TYPE: 'EXCLUSION_TYPE',
  An_error_occurred: 'An error occurred while creating the master data',
  Master_Type: 'Master Data Type',
  'Select master data type': 'Select master data type',
  Update: 'Update',
  'End Date': 'End Date',
  Search_by_master_data: 'Search by name...',
  Inclusions_and_Package: 'Inclusions and Package Highlights',
  Exclusions: 'Exclusions',
  'Upload Images': 'Upload Images',
  Days: 'Days',
  'Search by customer name, email,phone no,package name,vendor name...':
    'Search by customer name, email,phone no,package name,vendor name...',
  'Search by customer name, email,phone no,package name':
    'Search by customer name, email,phone no,package name',
  'From Date': 'From Date',
  'To Date': 'To Date',
  ID: 'ID',
  Search: 'Search',
  'Customer Lead': 'Customer Lead',
  'Vendor Lead': 'Vendor Lead',
  'Search by vendor name': 'Search by vendor name...',
  'Customer Lead Details': 'Customer Lead Details',
  'Vendor Lead Details': 'Vendor Lead Details',
  'Vendor List': 'Vendor List',
  'Lead Count': 'Lead Count',
  'Package Lead Count': 'Package Lead Count',
  'Search by name or email...': 'Search by name or email...',
  'Search by business name, mobile number, email or registered at...':
    'Search by business name, mobile number, email or registered at...',
  'Search by description': 'Search by description',
  'In-Active': 'In-Active',
  'The url field is required': 'The url field is required',
  'The description field is required': 'The description field is required',
  'The position field is required': 'The position field is required',
  'Business Information': 'Business Information',
  'Mobile Number': 'Mobile Number',
  'Email ID': 'Email ID',
  'Complete Your Profile': 'Complete Your Profile',
  Back: 'Back',
  'Complete Now': 'Complete Now',
  'Complete Your Profile in Just a Few Easy Steps!':
    'Complete Your Profile in Just a Few Easy Steps!',
  'Search by customer name or email...': 'Search by customer name or email...',
  'Search by package name...': 'Search by package name...',
  'Search by package name, package type or room sharing...':
    'Search by package name, package type or room sharing...',
  'Hajj/Umrah Package': 'Hajj/Umrah Package',
  'Customer Details': 'Customer Details',
  'Package Lead': 'Package Lead',
  'The Mobile No field is required': 'The Mobile No field is required',
  'The username field is required': 'The username field is required',
  'The email provided should be a valid email address':
    'The email provided should be a valid email address',
  'The email field is required': 'The email field is required',
  'The role field is required': 'The role field is required',
  'User Name': 'User Name',
  'Email address': 'Email address',
  'Edit Bottom  Banner': 'Edit Bottom  Banner',
  'Upload image': 'Upload image',
  'Bottom Banner Position': 'Bottom Banner Position',
  'The top banner created successfully': 'The top banner created successfully',
  'The banner has been updated': 'The banner has been updated',
  'Please upload an image': 'Please upload an image',
  'Top Banner Position': 'Top Banner Position',
  "Couldn't update Position": "Couldn't update Position",
  'Position has been updated': 'Position has been updated',
  'Bottom Banner': 'Bottom Banner',
  Position: 'Position',
  'The bottom banner status has been updated':
    'The bottom banner status has been updated',
  "Couldn't update bottom banner status":
    "Couldn't update bottom banner status",
  'The role account created successfully':
    'The role account created successfully',
  'Package Detail has been updated': 'Package Detail has been updated',
  'Error while saving package detail': 'Error while saving package detail',
  'Package detail saved successfully': 'Package detail saved successfully',
  'Package Details approved successfully':
    'Package Details approved successfully',
  'Error while approving Package Details':
    'Error while approving Package Details',
  'Hotel Details approved successfully': 'Hotel Details approved successfully',
  'Error while approving Hotel Details': 'Error while approving Hotel Details',
  'Tour Itinerary approved successfully':
    'Tour Itinerary approved successfully',
  'Error while approving Tour Itinerary':
    'Error while approving Tour Itinerary',
  'Error while approving Inclusions': 'Error while approving Inclusions',
  'Inclusions approved successfully': 'Inclusions approved successfully',
  'Exclusions approved successfully': 'Exclusions approved successfully',
  'Error while approving Exclusions': 'Error while approving Exclusions',
  'Comment Added Successfully': 'Comment Added Successfully',
  'The days are not specific to the provider dates':
    'The days are not specific to the provider dates',
  'Row saved successfully': 'Row saved successfully',
  'Row updated successfully': 'Row updated successfully',
  'Row deleted successfully': 'Row deleted successfully',
  'Row Saved Successfully': 'Row Saved Successfully',
  'Row has been updated': 'Row has been updated',
  'Row Deleted Successfully': 'Row Deleted Successfully',
  'An error occurred while creating the role':
    'An error occurred while creating the role',
  'Record has been updated': 'Record has been updated',
  'Error while updating record': 'Error while updating record',
  'Remark has been saved successfully': 'Remark has been saved successfully',
  'Error while saving remark': 'Error while saving remark',
  'Permissions has been updated': 'Permissions has been updated',
  'Package status has been updated': 'Package status has been updated',
  "Couldn't update package status": "Couldn't update package status",
  'Password successfully changed': 'Password successfully changed',
  'Image size is too large': 'Image size is too large',
  'The bottom banner created successfully':
    'The bottom banner created successfully',
  'The banner was updated successfully': 'The banner was updated successfully',
  'Role status has been updated': 'Role status has been updated',
  "Couldn't update role status": "Couldn't update role status",
  'The user account created successfully':
    'The user account created successfully',
  'User status has been updated': 'User status has been updated',
  "Couldn't update user status": "Couldn't update user status",
  'The card has been removed successfully':
    'The card has been removed successfully',
  'The master data added successfully': 'The master data added successfully',
  'The master data has been updated': 'The master data has been updated',
  'Master data status has been updated': 'Master data status has been updated',
  "Couldn't update master data status": "Couldn't update master data status",
  'Vendor details approved successfully':
    'Vendor details approved successfully',
  'Error while approving vendor details':
    'Error while approving vendor details',
  'Comment added successfully': 'Comment added successfully',
  'Business Information updated successfully':
    'Business Information updated successfully',
  'Error while updating Business Information':
    'Error while updating Business Information',
  'Documents updated successfully': 'Documents updated successfully',
  'Error while updating Documents': 'Error while updating Documents',
  'Types of Tour updated successfully': 'Types of Tour updated successfully',
  'Error while updating Types of Tour': 'Error while updating Types of Tour',
  'Payment Mode updated successfully': 'Payment Mode updated successfully',
  'Error while updating Payment Mode': 'Error while updating Payment Mode',
  'File uploaded successfully': 'File uploaded successfully',
  'Error while uploading file': 'Error while uploading file',
  'File deleted successfully': 'File deleted successfully',
  'Error while deleting file': 'Error while deleting file',
  'Package rejected successfully': 'Package rejected successfully',
  'An error occurred while rejecting package':
    'An error occurred while rejecting package',
  'Add Reason for Rejection': 'Add Reason for Rejection',
  'The Vendor account created successfully':
    'The Vendor account created successfully',
  'The user account has been updated': 'The user account has been updated',
  'Vendor status has been updated': 'Vendor status has been updated',
  'Could not update vendor status': 'Could not update vendor status',
  'Password has been successfully sent to you email':
    'Password has been successfully sent to you email',
  'Total Package Count': 'Total Package Count',
  'Total Lead Count': 'Total Lead Count',
  Active: 'Active',
  Inactive: 'Inactive',
  'Lead Management': 'Lead Management',
  Lead: 'Lead',
  'Are you sure you want to Activate this package?':
    'Are you sure you want to Activate this package',
  'Are you sure you want to In-Activate this package':
    'Are you sure you want to In-Activate this package',
  Activate: 'Activate',
  'In-Activate': 'In-Activate',
  'Are you sure you want to Activate this banner?':
    'Are you sure you want to Activate this banner?',
  'Are you sure you want to In-Activate this banner?':
    'Are you sure you want to In-Activate this banner?',
  'Are you sure you want to In-Activate this role?':
    'Are you sure you want to In-Activate this role?',
  'Are you sure you want to Activate this role?':
    'Are you sure you want to Activate this role?',
  'Are you sure you want to In-Activate this user':
    'Are you sure you want to In-Activate this user',
  'Are you sure you want to In-Activate this user?':
    'Are you sure you want to In-Activate this user?',
  'Are you sure you want to Activate this user?':
    'Are you sure you want to Activate this user?',
  'Are you sure you want to In-Activate this master data?':
    'Are you sure you want to In-Activate this master data?',
  'Are you sure you want to Activate this master data?':
    'Are you sure you want to Activate this master data?',
  'Are you sure you want to In-Activate this vendor?':
    'Are you sure you want to In-Activate this vendor?',
  'Are you sure you want to Activate this vendor?':
    'Are you sure you want to Activate this vendor?',
  'Banner Management': 'Banner Management',
  Banner: 'Banner',
  'Banner Top': 'Banner Top',
  'Banner Bottom': 'Banner Bottom',
  'Type of Tours Provided': 'Type of Tours Provided',
  Haj: 'Haj',
  Umrah: 'Umrah',
  Ziyarat: 'Ziyarat',
  Pincode: 'Pincode',
  Country: 'Country',
  State: 'State',
  'Select City': 'Select City',
  Landmark: 'Landmark',
  Area: 'Area',
  'Unit, Block, Wing, Building Name': 'Unit, Block, Wing, Building Name',
  'Street Name': 'Street Name',
  Address: 'Address',
  'Business Description': 'Business Description',
  'Uploading...': 'Uploading...',
  'Upload Company Logo': 'Upload Company Logo',
  'Company Logo': 'Company Logo',
  'Email Address': 'Email Address',
  'Year of Establishment': 'Year of Establishment',
  'Business Name': 'Business Name',
  'Account & Business Information': 'Account & Business Information',
  Cheque: 'Cheque',
  'Credit Card': 'Credit Card',
  'Debit Card': 'Debit Card',
  Cash: 'Cash',
  UPI: 'UPI',
  'Online Booking': 'Online Booking',
  'Demand Draft': 'Demand Draft',
  'Payment Mode': 'Payment Mode',
  'Member/Accredited/Authorised': 'Member/Accredited/Authorised',
  'IATA License': 'IATA License',
  'Upload IATA License': 'Upload IATA License',
  'Ministry of Tourism (GOI)': 'Ministry of Tourism (GOI)',
  'Allowed *.jpeg, *.jpg, *.png, *.pdf': 'Allowed *.jpeg, *.jpg, *.png, *.pdf',
  'Upload Ministry of Tourism (GOI)': 'Upload Ministry of Tourism (GOI)',
  HGO: 'HGO',
  'Upload HGO': 'Upload HGO',
  PAN: 'PAN',
  'Upload PAN': 'Upload PAN',
  'Business PAN': 'Business PAN',
  'Upload Business PAN': 'Upload Business PAN',
  'GST Number': 'GST Number',
  'Upload GST Certificate': 'Upload GST Certificate',
  'GST Certificate': 'GST Certificate',
  'Package Name is required': 'Package Name is required',
  'Package Type is required': 'Package Type is required',
  'Number of days is required': 'Number of days is required',
  'Number of days must be a positive number':
    'Number of days must be a positive number',
  'Number of days must be an integer': 'Number of days must be an integer',
  'Room sharing is required': 'Room sharing is required',
  'Room sharing must be at least 1 characters':
    'Room sharing must be at least 1 characters',
  'Room sharing must be at most 255 characters':
    'Room sharing must be at most 255 characters',

  'Airline is required': 'Airline is required',
  'Bus Service is required': 'Bus Service is required',
  'Departure date is required': 'Departure date is required',
  'Return Date is required': 'Return Date is required',
  'City is required': 'City is required',
  'Package Amount is required': 'Package Amount is required',
  'Package Amount must be a positive number':
    'Package Amount must be a positive number',
  'Business name is required': 'Business name is required',
  'The password field is required': 'The password field is required',
  'IATA License is required': 'IATA License is required',
  'File Size is too large': 'File Size is too large',
  'Ministry of Tourism is required': 'Ministry of Tourism is required',
  'HGO is required': 'HGO is required',
  'PAN is required': 'PAN is required',
  'Pan Card number is not valid': 'Pan Card number is not valid',
  'Business PAN is required': 'Business PAN is required',
  'Business Pan Card number is not valid':
    'Business Pan Card number is not valid',
  'GST number is not valid': 'GST number is not valid',
  'Pan Document is required': 'Pan Document is required',
  'Business Pan Document is required': 'Business Pan Document is required',
  'GST Certificate Document is required':
    'GST Certificate Document is required',
  'Unsupported Format': 'Unsupported Format',
  'Select city': 'Select city',
  Return: 'Return',
  'Hotel Details': 'Hotel Details',
  Distance: 'Distance',
  Location: 'Location',
  'Inclusions and Package Highlights': 'Inclusions and Package Highlights',
  'Registered At': 'Registered At',
  ALL: 'ALL',
  PENDING: 'PENDING',
  INPROCESS: 'INPROCESS',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  'The mobile no. must be at most 10 digits':
    'The mobile no. must be at most 10 digits',
  'The mobile no. must be at least 10 digits':
    'The mobile no. must be at least 10 digits',
  'The business name must be at most 50 characters':
    'The business name must be at most 50 characters',
  'The business name must be at least 1 character':
    'The business name must be at least 1 character',
  'The username must be at most 20 characters':
    'The username must be at most 20 characters',
  'The email field must be at least 3 characters':
    'The email field must be at least 3 characters',
  'The email must be at most 320 characters':
    'The email must be at most 320 characters',
  'The password must be at most 8 characters':
    'The password must be at most 8 characters',
  'The password field must be at least 8 characters':
    'The password field must be at least 8 characters',
  'Package Name must be at least 4 characters':
    'Package Name must be at least 4 characters',
  'Package Name must be at most 255 characters':
    'Package Name must be at most 255 characters',
  'Role name must be at least 1 character':
    'Role name must be at least 1 character',
  'Shortcode must be at most 5 characters':
    'Shortcode must be at most 5 characters',
  'Shortcode must be at least 1 character':
    'Shortcode must be at least 1 character',
  'Description must be at least 1 character':
    'Description must be at least 1 character',
  'Description must be at most 255 characters':
    'Description must be at most 255 characters',
  'Remark is required': 'Remark is required',
  'Remark must be at least 4 characters':
    'Remark must be at least 4 characters',
  'Remark must be at most 255 characters':
    'Remark must be at most 255 characters',
  'The name field must be at least 3 characters':
    'The name field must be at least 3 characters',
  'The name field must be at most 50 characters':
    'The name field must be at most 50 characters',
  'The role field must be at least 1 characters':
    'The role field must be at least 1 characters',
  'Password must be 8 characters long': 'Password must be 8 characters long',
  'Password requires a number': 'Password requires a number',
  'Password requires a lowercase letter':
    'Password requires a lowercase letter',
  'Password requires an uppercase letter':
    'Password requires an uppercase letter',
  'Password requires a symbol': 'Password requires a symbol',
  'The username field must be at least 3 characters':
    'The username field must be at least 3 characters',
  'The username field must be at most 20 characters':
    'The username field must be at most 20 characters',
  'The first name field must be at least 3 characters':
    'The first name field must be at least 3 characters',
  'The first name field must be at most 25 characters':
    'The first name field must be at most 25 characters',
  'The first name field is required': 'The first name field is required',
  'The last name field must be at least 3 characters':
    'The last name field must be at least 3 characters',
  'The last name field must be at most 25 characters':
    'The last name field must be at most 25 characters',
  'The last name field is required': 'The last name field is required',
  'Pincode must be an integer': 'Pincode must be an integer',
  'Pincode must be a positive number': 'Pincode must be a positive number',
  'Pincode is required': 'Pincode is required',
  'Pincode must be a number': 'Pincode must be a number',
  'Country is required': 'Country is required',
  'State is required': 'State is required',
  'Landmark is required': 'Landmark is required',
  'Area is required': 'Area is required',
  'Address is required': 'Address is required',
  'Street Name is required': 'Street Name is required',
  'Year of Establishment is required': 'Year of Establishment is required',
  'Comment is required': 'Comment is required',
  'Comment must be at least 1 character':
    'Comment must be at least 1 character',
  'Comment must be at most 255 characters':
    'Comment must be at most 255 characters',
  'You must agree to our terms and conditions':
    'You must agree to our terms and conditions',
  'Inactive Top Banners': 'Inactive Top Banners',
  'Inactive Bottom Banners': 'Inactive Bottom Banners',
  'Mobile Image': 'Mobile Image',
  'Desktop Image': 'Desktop Image',
  'Banner Created Date': 'Banner Created Date',
  'Banner Updated Date': 'Banner Updated Date',
  'Maximum number of active banners exeeded':
    'Maximum number of active banners exeeded',
  'Image dimension should be greater than 1000 X 1900 px':
    'Image dimension should be greater than 1000 X 1900 px',
  'Image dimension should be greater than 380 X 499 px':
    'Image dimension should be greater than 380 X 499 px',
  'Search by url...': 'Search by url...',
  'Change Your Password': 'Change Your Password',
  'Enter your new password': 'Enter your new password',
  Notifications: 'Notifications',
  'Reset Password': 'Reset Password',
  Profile: 'Profile',
  'Sign Out': 'Sign Out',
  'Profile Under Review': 'Profile Under Review',
  'Review And Rating': 'Review And Rating',
  'Review And Rating Management': 'Review And Rating Management',
  'Search by customer name,email,package name,vendor name...':
    'Search by customer name,email,package name,vendor name...',
  Content: 'Content',
  'Content Management': 'Content Management',
  Preview: 'Preview',
  Upload: 'Upload',
  Title: 'Title',
  'Top Banner Clicks Detail': 'Top Banner Clicks Detail',
  'Bottom Banner Clicks Detail': 'Bottom Banner Clicks Detail',
  'Inactive Top Banner Clicks Detail': 'Inactive Top Banner Clicks Detail',
  'Inactive Bottom Banner Clicks Detail':
    'Inactive Bottom Banner Clicks Detail',
  'Clicks Detail': 'Clicks Detail',
  'Are you sure you want to Activate this content?':
    'Are you sure you want to Activate this content?',
  'Are you sure you want to In-Activate this content?':
    'Are you sure you want to In-Activate this content?',
  'Enter title': 'Enter title',
  'Please enter content title': 'Please enter content title',
  'Please enter description': 'Please enter description',
  'FOOD RATING': 'FOOD RATING',
  'HOTEL RATING': 'HOTEL RATING',
  'JIYARAT RATING': 'JIYARAT RATING',
  COMMENTS: 'COMMENTS',
  'Search by title,subtitle and description...':
    'Search by title,subtitle and description...',
  'Sub Title': 'Sub Title',
  'How to choose your tour packages?': 'How to choose your tour packages?',
  'How to apply for Haj?': 'How to apply for Haj?',
  'Type of Hajj': 'Type of Hajj',
  'Highest standards of professionalism, integrity, and personal service':
    'Highest standards of professionalism, integrity, and personal service',
  'Full co-ordination during your stay': 'Full co-ordination during your stay',
  'Exclusive deals with leading Umrah service providers in Saudi Arabia':
    'Exclusive deals with leading Umrah service providers in Saudi Arabia',
  Question: 'Question',
  Answer: 'Answer',
  Keyword: 'Keyword',
  'Apply for Haj': 'Apply for Haj',
  'Type of Haj': 'Type of Haj',
  'Choose tour packages': 'Choose tour packages',
  Standards: 'Standards',
  Stay: 'Stay',
  'Exclusive deals': 'Exclusive deals',
  'The content has been updated': 'The content has been updated',
  'Record status has been updated': 'Record status has been updated',
  "Couldn't update content status": "Couldn't update content status",
  'The content saved successfully': 'The content saved successfully',
  'The content updated successfully': 'The content updated successfully',
  'FAQ record deleted successfully': 'FAQ record deleted successfully',
  'An error occured while updating FAQ': 'An error occured while updating FAQ',
  'An error occured while saving FAQ': 'An error occured while saving FAQ',
  'FAQ updated successfully': 'FAQ updated successfully',
  'FAQ saved successfully': 'FAQ saved successfully',
  'Spaces are not allowed': 'Spaces are not allowed',
  'Record deleted successfully': 'Record deleted successfully',
  'Content Pages': 'Content Pages',
  'Content Sections': 'Content Sections',
  'Tree View': 'Tree View',
  'Search by page name or menu name...': 'Search by page name or menu name...',
  'Section name': 'Section name',
  'Page name': 'Page name',
  'Menu Name': 'Menu Name',
  'View & Edit': 'View & Edit',
  'Enter section name': 'Enter section name',
  'Enter page name': 'Enter page name',
  'Enter menu name': 'Enter menu name',
  'Enter keyword': 'Enter keyword',
  'Add FAQ': 'Add FAQ',
  'Update & Publish': 'Update & Publish',
  'Save & Publish': 'Save & Publish',
  'The content field is required': 'The content field is required',
  'Icon dimension is not correct': 'Icon dimension is not correct',
  'Please select a PNG image': 'Please select a PNG image',
  'Update Section Details': 'Update Section Details',
  'Add Section Details': 'Add Section Details',
  Icon: 'Icon',
  'No file is selected': 'No file is selected',
  'Upload Icon': 'Upload Icon',
  'Minimum height and width should be 600 X 1000 pixel':
    'Minimum height and width should be 600 X 1000 pixel',
  'Minimum height and width should be 800 X 1200 pixel':
    'Minimum height and width should be 800 X 1200 pixel',
  'Upload image for Mobile': 'Upload image for Mobile',
  'Upload image for Desktop': 'Upload image for Desktop',
  'Add Banner Details': 'Add Banner Details',
  'Allowed *.jpeg, *.jpg, *.png, *.gif': 'Allowed *.jpeg, *.jpg, *.png, *.gif',
  'Allowed *.png': 'Allowed *.png',
  'Minimum height and width should be 32 X 32 pixel':
    'Minimum height and width should be 32 X 32 pixel',
  'Mobile Image uploaded successfully': 'Mobile Image uploaded successfully',
  'Error while uploading an image': 'Error while uploading an image',
  'Desktop Image uploaded successfully': 'Desktop Image uploaded successfully',
  'Icon uploaded successfully': 'Icon uploaded successfully',
  'Error while uploading an icon': 'Error while uploading an icon',
  'Currency status has been updated': 'Currency status has been updated',
  'Could not update Currency status': 'Could not update Currency status',
  'The currency field must be at least 1 characters':
    'The currency field must be at least 1 characters',
  'The currency field is required': 'The currency field is required',
  'The currency has been added sucessfuly':
    'The currency has been added sucessfuly',
  'Currency Name': 'Currency Name',
  'Available Currencies': 'Available Currencies',
  'Are you sure you want to logout?': 'Are you sure you want to logout?',
  Yes: 'Yes',
  'The admin will review your profile, and approval will be granted once the review process is complete.':
    'The admin will review your profile, and approval will be granted once the review process is complete.',
  'Your Profile Is Not Approved Yet': 'Your Profile Is Not Approved Yet',
  "You can add your packages once your profile is complete. Click the 'Complete Profile' button to fill in the necessary details and start adding your packages.":
    "You can add your packages once your profile is complete. Click the 'Complete Profile' button to fill in the necessary details and start adding your packages.",
  "You can start adding your packages once your profile is approved. We'll notify you as soon as your profile is ready for package submissions. In the meantime, feel free to explore other features!":
    "You can start adding your packages once your profile is approved. We'll notify you as soon as your profile is ready for package submissions. In the meantime, feel free to explore other features!",
  'Complete Profile': 'Complete Profile',
  'If you make any edits to the details below, this package will be subject to review again. During this review period, this package will not be visible on the customer portal until it is approved again.':
    'If you make any edits to the details below, this package will be subject to review again. During this review period, this package will not be visible on the customer portal until it is approved again.',
  "If you make any edits to the details below, this vendor's profile will be subject to review again. During this review period, his/her packages will not be visible on the customer portal until his/her profile is approved.":
    "If you make any edits to the details below, this vendor's profile will be subject to review again. During this review period, his/her packages will not be visible on the customer portal until his/her profile is approved.",
  'If you make any edits to the details below, your profile will be subject to review again. During this review period, your packages will not be visible on the customer portal until your profile is approved.':
    'If you make any edits to the details below, your profile will be subject to review again. During this review period, your packages will not be visible on the customer portal until your profile is approved.',
  'Rejection Reason': 'Rejection Reason',
  'Vendor Type': 'Vendor Type',
  'Service Description': 'Service Description',
  'Service Description must be at least 1 character':
    'Service Description must be at least 1 character',
  'Service Description must be at most 255 characters':
    'Service Description must be at most 255 characters',
  'Service Description is required': 'Service Description is required',
  'Business Description must be at least 1 character':
    'Business Description must be at least 1 character',
  'Business Description must be at most 255 characters':
    'Business Description must be at most 255 characters',
  'Business Description is required': 'Business Description is required',
  'Review Profile': 'Review Profile',
  'Already Rejected': 'Already Rejected',
  'Already Approved': 'Already Approved',
  Finish: 'Finish',
  'Update & Next': 'Update & Next',
  'Business TAN': 'Business TAN',
  Reject: 'Reject',
  Approve: 'Approve',
  'Disable Edit': 'Disable Edit',
  'REVIEW AND RATING': 'REVIEW AND RATING',
  'Inquiry Status': 'Inquiry Status',
  'Booking Status': 'Booking Status',
  Date: 'Date',
  Comment: 'Comment',
  'Domain Name': 'Domain Name',
  'Comment added and vendor rejected successfully':
    'Comment added and vendor rejected successfully',
  'Comment added and package rejected successfully':
    'Comment added and package rejected successfully',
  'The domain name must be at least 1 character':
    'The domain name must be at least 1 character',
  'The domain name must be at most 100 characters':
    'The domain name must be at most 100 characters',
  'Only -, _, & characters are allowed and no spaces':
    'Only -, _, & characters are allowed and no spaces',
  'The domain name field is required': 'The domain name field is required',
  'Domain name already exists': 'Domain name already exists',
  'No Images Found': 'No Images Found',
  "You can select a maximum of 5 images. Please deselect an image before selecting another if you've reached the limit.":
    "You can select a maximum of 5 images. Please deselect an image before selecting another if you've reached the limit.",
  'Choose Any 5 Best Images': 'Choose Any 5 Best Images',
  'Makkah Hotel Details': 'Makkah Hotel Details',
  'Madinah Hotel Details': 'Madinah Hotel Details',
  'Only JPEG, JPG, PNG, and PDF files are supported. Please upload a valid file.':
    'Only JPEG, JPG, PNG, and PDF files are supported. Please upload a valid file.',
  'Only JPEG, JPG, PNG, and GIF files are supported. Please upload a valid file.':
    'Only JPEG, JPG, PNG, and GIF files are supported. Please upload a valid file.',
  'Error while downloading file': 'Error while downloading file',
  'File downloaded successfully': 'File Downloaded Successfully',
  'File size exceeds the maximum limit of 2MB.':
    'File size exceeds the maximum limit of 2MB.',
  'Location Master': 'Location Master',
  'Add Location': 'Add Location',
  'Update Location': 'Update Location',
  'City Name': 'City Name',
  'State Name': 'State Name',
  'Country Name': 'Country Name',
  'City Image': 'City Image',
  'Select Image': 'Select Image',
  'Location added successfully': 'Location added successfully',
  'Location updated successfully': 'Location updated successfully',
  'Status updated successfully': 'Status updated successfully',
  'Failed to update status': 'Failed to update status',
  'Search by country or city...': 'Search by country or city...',
  'No locations found': 'No locations found',
  'State Name (Optional)': 'State Name (Optional)',
  'Default State': 'Default State'
};

export default enJSON;
